import React, { Fragment } from 'react';
import { ModalsService } from '@mdigital/components/dist/utils/modals';
import { getSingleText } from '../../../common/utils';
import PropTypes from 'prop-types';
import { StyledPublishBlockedDialog } from './StyledPublishBlockedDialog';

const PublishBlockedDialog = (props) => {
  const { groupedResources } = props;
  
  // Calculate total count for plural detection
  const resourceCount = Object.values(groupedResources).reduce((sum, arr) => sum + arr.length, 0);
  const isPlural = resourceCount > 1;

  return props.render({
    size: 'small',
    title: getSingleText('app.pages.forms.publishBlocked.title'),
    body: (
      <StyledPublishBlockedDialog>
        <p>
          {isPlural
            ? getSingleText('app.pages.forms.publishBlocked.messageMultiple')
            : getSingleText('app.pages.forms.publishBlocked.messageSingle')}
        </p>
        
        {Object.entries(groupedResources).map(([textKey, resources]) => 
          resources.length > 0 && (
            <Fragment key={textKey}>
              <strong>{getSingleText(`app.pages.forms.publishBlocked.${textKey}`)}</strong>
              <ul>
                {resources.map((resource, index) => (
                  <li key={index}>
                    {resource.fileName}.{resource.fileType}
                  </li>
                ))}
              </ul>
            </Fragment>
          )
        )}
        
        <p className="instruction">
          {isPlural
            ? getSingleText('app.pages.forms.publishBlocked.instructionMultiple')
            : getSingleText('app.pages.forms.publishBlocked.instructionSingle')}
        </p>
      </StyledPublishBlockedDialog>
    ),
    close: {
      title: getSingleText('app.pages.forms.publishBlocked.confirm'),
      priority: 'primary',
    },
  });
};

export const openBlockPublishDialog = ({ draftResources }) => {
  ModalsService.showCustomModal(PublishBlockedDialog, {
    groupedResources: draftResources,
  });
};

PublishBlockedDialog.propTypes = {
  groupedResources: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        url: PropTypes.string,
        isDeployed: PropTypes.bool,
      })
    )
  ).isRequired,
};
